var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPresentation = function SvgPresentation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.2,
    cy: 4.8,
    rx: 4.9,
    ry: 4.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 22.6v-6.3c0-2.5-2.1-4.2-4.4-4.8-2.5-.6-5.1.6-7.5-.2-1.6-.5-2.5-.9-3.8-1.8L4.6 1.9C4.4 1 3.7.7 3.1.9c-.7.1-1.1.7-.9 1.4l1.6 6.4c-.5.2-.9.5-1.2.9-.9 1.1-.7 2.7.4 3.6 2 1.6 3.4 2.3 5.9 3 0 0 1.8.5 1.8 1.2v5.2c3.8 1.9 8 1.8 11.3 0z"
  })));
};
export default SvgPresentation;